import { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContextApi } from "../../../store/ContextApi";
import PageTitle from "../../layouts/PageTitle";
import SpinnerLoading from "../../components/spinner-loading/SpinnerLoading";
import FaildLoadData from "../../global-components/FaildLoadData/FaildLoadData";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
import { toast } from "react-toastify";
import { getUsersFunc } from "../../../store/custom-actions/users-actions/GetUsersSlicer";
import { deleteUserFunc } from "../../../store/custom-actions/users-actions/DeleteUserSlicer";
import UsersDescion from "./UsersDescion";
import ChangeUserPassForm from "../../custom-forms/users/ChangePassForm";
import UpdateUserStatus from "../../custom-forms/users/UpdateUserStatus";
import defaultUserImage from "../../../media/images/user (2).png";
import checkPermissions from "../../global-functions/checkPermissionsFunc";
import { useTranslation } from "react-i18next";

export default function UsersPage() {
  const { t } = useTranslation();
  const { loading: getUsersLoading, data: usersData } = useSelector(
    (state) => state.getUsersSlicer
  );
  const { loading: deleteUserLoading } = useSelector(
    (state) => state.deleteUserSlicer
  );
  const contextApi = useContext(ContextApi);
  const users_API_URL = `${process.env.REACT_APP_VERSEL_API}/api/dashboard/users`;
  const [usersList, setUsersList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [showChangePass, setShowChangePass] = useState();
  const [userWhichUpdateId, setUserWhichUpdateId] = useState();
  const [showUpdateStatus, setShowUpdateStatus] = useState();
  const [oldActivaty, setOldActivaty] = useState();
  const [oldEmailVerifed, setOldEmailVerifed] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    const getUsers = async () => {
      try {
        dispatch(getUsersFunc(users_API_URL));
      } catch (error) {
        console.log(error);
      }
    };
    getUsers();
  }, []);
  useEffect(() => {
    usersData && setUsersList(usersData);
    usersData &&
      (jobData.current = usersData.slice(
        activePag.current * sort,
        (activePag.current + 1) * sort
      ));
  }, [usersData]);
  const sort = 20;
  let paggination = Array(Math.ceil(usersList.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const activePag = useRef(0);
  const jobData = useRef(
    usersList.slice(activePag.current * sort, (activePag.current + 1) * sort)
  );
  const onClick = (i) => {
    activePag.current = i;
    jobData.current = usersList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
  };
  const search = () => {
    if (searchValue !== "") {
      const searchResult =
        usersData &&
        usersData.length >= 1 &&
        usersData.filter(
          (user) =>
            user.first_name
              .toLocaleLowerCase()
              .includes(searchValue.toLocaleLowerCase()) ||
            user.last_name
              .toLocaleLowerCase()
              .includes(searchValue.toLocaleLowerCase())
        );
      jobData.current = searchResult;
    } else {
      dispatch(getUsersFunc(users_API_URL));
    }
  };
  useEffect(() => {
    searchValue == "" && dispatch(getUsersFunc(users_API_URL));
  }, [searchValue]);
  const deleteUserFunction = async (id) => {
    swal({
      title: t("Confirm User Deletion"),
      text: t(`Once deleted, This User will not be avilable`),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        dispatch(deleteUserFunc(`${users_API_URL}/${id}`)).then((result) => {
          if (result.payload.success == true) {
            dispatch(getUsersFunc(users_API_URL));
            toast.success(`${result.payload.message} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        });
      }
    });
  };
  return (
    <>
      <PageTitle motherMenu={"Dashboard"} activeMenu={"Users"} />
      {getUsersLoading ? (
        <SpinnerLoading />
      ) : usersData ? (
        usersList &&
        usersList.length >= 1 && (
          <div className="col-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">{t("Users")}</h4>
                <div className="d-flex align-items-center">
                  <div className="input-group me-2">
                    <span
                      className="input-group-text"
                      onClick={() => search()}
                      style={{ cursor: "pointer" }}
                    >
                      <Link to={"#"}>
                        <i className="bi bi-search"></i>
                      </Link>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Search here...")}
                      onChange={(e) => {
                        setSearchValue(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive w-100">
                  <table className="table table-striped align-middle mb-0">
                    <thead>
                      <tr>
                        <th>{t("ID")}</th>
                        <th>{t("First name")}</th>
                        <th>{t("Last name")}</th>
                        <th>{t("Email")}</th>
                        <th>{t("Status")}</th>
                        <th>{t("Verified")}</th>
                        {checkPermissions(
                          ["delete users", "update users"],
                          <th>{t("Actions")}</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {jobData.current.map((user, index) => (
                        <tr key={index}>
                          <td>{user.id}</td>
                          <td>
                            <Link
                              to={`/user-profile/${user.id}`}
                              className="d-flex align-items-center text-decoration-none"
                            >
                              <img
                                src={
                                  user.image_url
                                    ? user.image_url
                                    : defaultUserImage
                                }
                                className="rounded-circle me-2"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  objectFit: "cover",
                                  cursor: "pointer",
                                }}
                                alt="user img"
                              />
                              {user.first_name}
                            </Link>
                          </td>
                          <td>{user.last_name}</td>
                          <td>{user.email}</td>
                          <td>
                            <span
                              className={`badge ${
                                user.active ? "bg-success" : "bg-danger"
                              }`}
                            >
                              {user.active ? t("Active") : t("Not Active")}
                            </span>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                user.is_email_verified
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {user.is_email_verified
                                ? t("Verified")
                                : t("Not verified")}
                            </span>
                          </td>
                          {checkPermissions(
                            ["delete users", "update users"],
                            <td>
                              <UsersDescion
                                deleteFunction={() =>
                                  deleteUserFunction(user.id)
                                }
                                showChangePassForm={() => {
                                  setShowChangePass(true);
                                  setUserWhichUpdateId(user.id);
                                }}
                                showUpdateStatusForm={() => {
                                  setShowUpdateStatus(true);
                                  setUserWhichUpdateId(user.id);
                                  setOldActivaty(user.active);
                                  setOldEmailVerifed(user.is_email_verified);
                                }}
                              />
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Pagination */}
                  <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-2">
                    <div className="dataTables_info">
                      {t("Showing")} {activePag.current * sort + 1} to{" "}
                      {usersList.length > (activePag.current + 1) * sort
                        ? (activePag.current + 1) * sort
                        : usersList.length}{" "}
                      {t("Of")} {usersList.length} {t("Entries")}
                    </div>
                    <div className="pagination mb-0">
                      <Link
                        className={`page-link ${
                          activePag.current === 0 ? "disabled" : ""
                        }`}
                        to="#"
                        onClick={() =>
                          activePag.current > 0 &&
                          onClick(activePag.current - 1)
                        }
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </Link>
                      {paggination.map((number, i) => (
                        <Link
                          key={i}
                          to="#"
                          className={`page-link ${
                            activePag.current == i ? "active" : ""
                          }`}
                          onClick={() => onClick(i)}
                        >
                          {number}
                        </Link>
                      ))}
                      <Link
                        className={`page-link ${
                          activePag.current + 1 >= paggination.length
                            ? "disabled"
                            : ""
                        }`}
                        to="#"
                        onClick={() =>
                          activePag.current + 1 < paggination.length &&
                          onClick(activePag.current + 1)
                        }
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      ) : (
        <FaildLoadData
          refetchDataFunc={() => dispatch(getUsersFunc(users_API_URL))}
        />
      )}

      {/* Modals */}
      <LoadingScreen loading={deleteUserLoading} />
      <ChangeUserPassForm
        show={showChangePass}
        onHide={() => setShowChangePass(false)}
        userId={userWhichUpdateId}
      />
      <UpdateUserStatus
        show={showUpdateStatus}
        onHide={() => setShowUpdateStatus(false)}
        userId={userWhichUpdateId}
        oldActivaty={oldActivaty}
        oldVerifing={oldEmailVerifed}
      />
    </>
  );
}
